const loginSidePanel = function (titleType) {
    const $sidePanel = $('.login-side-panel');
    const openSidePanel = function () {
        $('.login-panel__title h2').addClass('hide');
        $sidePanel.remodal().open();

        switch(titleType) {
            case 'favourite':
                $('.title-favourite').removeClass('hide');
                break;
            case 'coupons':
                $('.title-coupons').removeClass('hide');
                break;
            case 'quickShop':
                $('.title-quickShop').removeClass('hide');
                break;
            case 'orders':
                $('.title-orders').removeClass('hide');
                break;
            default:
                $('.title-default').removeClass('hide');
        }
    };

    openSidePanel();
};

const submitLoginSignupForm = function (event) {
    event.preventDefault();
    let $submitButton = $(event.target);
    let url = $submitButton.data('url');
    $('#loginSidePanelForm').attr('action', url).submit();
}